import { useCallback, useSyncExternalStore } from "react";

/** Whether the media element is playing, kept current from its own events. */
export function useAudioIsPlaying(nativeAudio: HTMLMediaElement | null) {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      nativeAudio?.addEventListener("emptied", onStoreChange);
      nativeAudio?.addEventListener("play", onStoreChange);
      nativeAudio?.addEventListener("pause", onStoreChange);

      return () => {
        nativeAudio?.removeEventListener("emptied", onStoreChange);
        nativeAudio?.removeEventListener("play", onStoreChange);
        nativeAudio?.removeEventListener("pause", onStoreChange);
      };
    },
    [nativeAudio],
  );

  return useSyncExternalStore(subscribe, () =>
    nativeAudio ? !nativeAudio.paused : false,
  );
}

export function toggleAudioPlayback(nativeAudio: HTMLMediaElement | null) {
  if (!nativeAudio) {
    return;
  }
  if (!nativeAudio.paused) {
    nativeAudio.pause();
  } else {
    void nativeAudio.play().catch(() => undefined);
  }
}
